/* Copy Pack button — opens the stage-aware pack dialog. Mounted in the
 * Build journey stepper AND in the Workflows / Journeys / Identity toolbars
 * (context-aware: same pack as their stage). */
import React, {
    useState
} from 'react';
import {
    PackageOpen
} from 'lucide-react';
import CopyPackDialog from './CopyPackDialog';
import type {
    PackCurrentDoc,
    PackStage
} from './copyPack';

export default function CopyPackButton({
    stage,
    currentDoc,
    block = false,
    primary = false,
    onCopied
}: {
    stage: PackStage;
    /** The live editor text when an existing item is open. */
    currentDoc?: PackCurrentDoc | null;
    /** Full-width (rail / list-column placement). */
    block?: boolean;
    primary?: boolean;
    /** Fires after a successful copy (Build tab → paste-result panel). */
    onCopied?: () => void;
}) {
    const [open, setOpen] = useState(false);
    return (
        <>
            <button
                className={'aps-btn aps-btn-sm '
                    + (primary ? 'aps-btn-primary' : 'aps-btn-secondary')}
                style={block ? {
                    width: '100%'
                } : undefined}
                title="Copy the authoring guide + this stage's dependency docs for your LLM"
                onClick={() => setOpen(true)}
            >
                <PackageOpen size={14} />
                Copy pack
            </button>
            {open && (
                <CopyPackDialog
                    stage={stage}
                    currentDoc={currentDoc}
                    open={open}
                    onOpenChange={setOpen}
                    onCopied={onCopied}
                />
            )}
        </>
    );
}
